if(!customElements.get('bezelor-coupon'))customElements.define('bezelor-coupon',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const dialog=this.querySelector('dialog'),opener=this.querySelector('[data-coupon-open]'),status=this.querySelector('[role="status"]');
this.dialog=dialog;
const end=Date.parse(this.dataset.end);if(Number.isFinite(end)&&Date.now()>=end){this.hidden=true;return;}
opener.addEventListener('click',()=>{if(Number.isFinite(end)&&Date.now()>=end){this.hidden=true;return;}this.oldOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';});
this.querySelector('[data-coupon-close]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
dialog.addEventListener('close',()=>{document.body.style.overflow=this.oldOverflow||'';opener.focus({preventScroll:true});});
this.querySelectorAll('[data-coupon-copy]').forEach(copy=>copy.addEventListener('click',async()=>{
if(this.applying)return;
this.applying=true;
const buttons=[...this.querySelectorAll('[data-coupon-copy]')];
const value=copy.closest('.bz-coupon-code').querySelector('[data-coupon-value]');
const code=value.textContent.trim();
buttons.forEach(button=>{button.dataset.original ||= button.textContent;button.disabled=true;});
copy.textContent=this.dataset.applying;
status.textContent=this.dataset.applying;
let copied=false;
const clipboard=navigator.clipboard?.writeText(code).then(()=>{copied=true;}).catch(()=>{});
try{
const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:code})});
if(!response.ok)throw new Error('Cart update failed');
const cart=await response.json();
const same=text=>String(text||'').toUpperCase()===code.toUpperCase();
const applications=[...(cart.cart_level_discount_applications||[]),...(cart.items||[]).flatMap(item=>(item.line_level_discount_allocations||[]).map(a=>a.discount_application))];
const applied=(cart.discount_codes||[]).some(d=>same(d.code)&&d.applicable===true)||applications.some(d=>same(d.title)&&d.type==='discount_code');
status.textContent=applied?this.dataset.success:this.dataset.pending;
copy.textContent=applied?this.dataset.applied:copy.dataset.copied;
if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'bezelor-coupon',cartData:cart});
}catch(error){status.textContent=this.dataset.failed;copy.textContent=copy.dataset.original;}
finally{
await clipboard;
if(!copied){const range=document.createRange();range.selectNodeContents(value);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);}
buttons.forEach(button=>{button.disabled=false;if(button!==copy)button.textContent=button.dataset.original;});
this.applying=false;
}
}));
}
disconnectedCallback(){if(this.dialog?.open){this.dialog.close();document.body.style.overflow=this.oldOverflow||'';}}
});